var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.16,
    height: 60,
    viewBox: "0 0 51.16 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_164",
    "data-name": "Subtraction 164",
    d: "M20601.057,13660.835h-30.941a10,10,0,0,1-10.113-10.1v-39.793a10,10,0,0,1,10.113-10.1h22.1a1.09,1.09,0,0,1,.885.385l17.684,17.682a1.087,1.087,0,0,1,.379.881v30.949A10,10,0,0,1,20601.057,13660.835Zm-30.941-57.465a7.458,7.458,0,0,0-7.574,7.568v39.793a7.453,7.453,0,0,0,7.574,7.565h30.941a7.441,7.441,0,0,0,7.566-7.565v-29.678h-12.43a5.257,5.257,0,0,1-5.25-5.25v-12.434Zm23.371,1.764h0v10.67a2.835,2.835,0,0,0,2.707,2.712h10.67l-13.377-13.382Zm-7.9,42.44a10,10,0,0,1-10.113-10.109,10.133,10.133,0,0,1,8.1-9.911l.738-.16v-1.918h-.937a1.271,1.271,0,1,1,0-2.542h4.42a1.271,1.271,0,0,1,0,2.542h-.939v1.918l.742.16a10.134,10.134,0,0,1,8.1,9.911A10,10,0,0,1,20585.588,13647.574Zm0-17.677a7.449,7.449,0,1,0,5.387,2.182A7.573,7.573,0,0,0,20585.588,13629.9Zm0,8.839a1.16,1.16,0,0,1-1.275-1.271v-2.212a1.271,1.271,0,0,1,2.543,0v2.212A1.155,1.155,0,0,1,20585.588,13638.736Z",
    transform: "translate(-20560.002 -13600.835)",
    fill: "#a49dc8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivity);
export default __webpack_public_path__ + "static/media/NoActivity.2ecf1fce3beef41bcdab7a373624ddd7.svg";
export { ForwardRef as ReactComponent };